module.exports = __webpack_public_path__ + "img/49_11.1daa8a40.png";